import { memo, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import SpinnerLoader from 'src/libraries/SpinnerLoader';
import AuthService from 'src/services/auth.service';
import TaiKhoanService from 'src/services/TaiKhoan.service';
import { useTaiKhoan } from 'src/stores';
import { IBaseProps } from 'src/types/common.type';

const svTaiKhoan = new TaiKhoanService();
const svAuth = new AuthService();

function InitAppProvider({ children }: IBaseProps) {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState<boolean>(false);
  const [init, setInit] = useState<boolean>(false);
  // const { refresh } = useRefresh();
  const { doiTaiKhoan } = useTaiKhoan();
  const token_grant = searchParams.get('token_grant');

  useEffect(() => {
    fetchInit();
  }, [token_grant]);

  const fetchInit = async () => {
    if (loading) return;
    setLoading(true);
    try {
      if (token_grant) {
        await svAuth.grant({ token_grant });
      }
      const account = await svTaiKhoan.thongTinCaNhan();

      doiTaiKhoan(account);

      setInit(true);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  if (loading || !init) return <SpinnerLoader bg={false} />;

  return children;
}

export default memo(InitAppProvider);
